import $ from 'jquery/src/jquery';

export default () => {
  const nodeSelectors = {
    container: '[js-site-front-page="container"]',
    singleFilter: '[js-site-front-page="filter"]',
    numbers: '.our-numbers .number',
  };

  function init() {
    if (!document.querySelector(nodeSelectors.container)) {
      return;
    }

    initAbout();
    initNumbersCounter();
  }

  // function initAbout() {
  //   $(nodeSelectors.singleFilter).on('click', function () {
  //     const currentImage = $(this).data('image');
  //     const currentText = $(this).data('text');

  //     $('.tech-areas .left .gl-text-editor').html(currentText);
  //     $('.tech-areas .right .middle-image img').attr('src', currentImage);
  //   });
  // }

  // function initAbout() {
  //   const $filters = $('[js-site-front-page="filter"]'); // your "singleFilter" elements
  //   const $textTarget = $('.tech-areas .left .gl-text-editor');
  //   const $imageTarget = $('.tech-areas .right .middle-image img');

  //   if (!$filters.length) return;

  //   let currentIndex = 0;
  //   let autoTimer = null;
  //   let autoStoppedByUser = false;

  //   function applyFilter($el) {
  //     const currentImage = $el.data('image');
  //     const currentText = $el.data('text');

  //     // active class
  //     $filters.removeClass('active');
  //     $el.addClass('active');

  //     // update content
  //     if (typeof currentText !== 'undefined') $textTarget.html(currentText);
  //     if (typeof currentImage !== 'undefined') $imageTarget.attr('src', currentImage);

  //     // keep index in sync (important when user clicks)
  //     currentIndex = $filters.index($el);
  //   }

  //   function startAuto() {
  //     stopAuto(); // avoid double intervals

  //     autoTimer = setInterval(() => {
  //       if (autoStoppedByUser) return;

  //       const $next = $filters.eq(currentIndex);
  //       applyFilter($next);

  //       currentIndex = (currentIndex + 1) % $filters.length;
  //     }, 5000);
  //   }

  //   function stopAuto() {
  //     if (autoTimer) {
  //       clearInterval(autoTimer);
  //       autoTimer = null;
  //     }
  //   }

  //   // initial state: set first one active + apply its data
  //   applyFilter($filters.eq(0));
  //   currentIndex = 1; // so the next auto step moves to the 2nd item

  //   // user click: apply + stop automation
  //   $filters.on('click', function () {
  //     autoStoppedByUser = true;
  //     stopAuto();
  //     applyFilter($(this));
  //   });

  //   // start the 5s rotation
  //   startAuto();
  // }

  function initAbout() {
  const $textTarget = $('.tech-areas .left .gl-text-editor');
  const $imageTarget = $('.tech-areas .right .middle-image img');

  const $desktopFilters = $('.tech-areas .right .right-content [js-site-front-page="filter"]:not(.mobile)');
  const $mobileFilters  = $('.tech-areas .right > [js-site-front-page="filter"].mobile');

  // pick which set is currently active (visible) based on CSS display
  function getActiveSet() {
    // if desktop filters are visible use them, else use mobile
    if ($desktopFilters.length && $desktopFilters.filter(':visible').length) return $desktopFilters;
    if ($mobileFilters.length) return $mobileFilters;
    return $(); // none
  }

  let $filters = getActiveSet();
  if (!$filters.length) return;

  let currentIndex = 0;
  let autoTimer = null;
  let autoStoppedByUser = false;

  function applyFilter($el) {
    const currentImage = $el.data('image');
    const currentText = $el.data('text');

    // active class ONLY within the current active set
    $filters.removeClass('active');
    $el.addClass('active');

    if (typeof currentText !== 'undefined') $textTarget.html(currentText);
    if (typeof currentImage !== 'undefined') $imageTarget.attr('src', currentImage);

    currentIndex = $filters.index($el);
  }

  function stopAuto() {
    if (autoTimer) {
      clearInterval(autoTimer);
      autoTimer = null;
    }
  }

  function startAuto() {
    stopAuto();
    autoTimer = setInterval(() => {
      if (autoStoppedByUser) return;
      $filters = getActiveSet();
      if (!$filters.length) return;

      const $next = $filters.eq(currentIndex);
      applyFilter($next);

      currentIndex = (currentIndex + 1) % $filters.length;
    }, 5000);
  }

  // Apply first visible filter on load
  $filters = getActiveSet();
  applyFilter($filters.eq(0));
  currentIndex = 1;

  // Click handling for BOTH sets, but only affect current active set
  $desktopFilters.add($mobileFilters).on('click', function () {
    autoStoppedByUser = true;
    stopAuto();

    // refresh active set (in case user clicked after resize/breakpoint change)
    $filters = getActiveSet();

    // if user clicked an element from the other set (hidden), map by index
    const $clicked = $(this);
    const idxInItsSet = $clicked.hasClass('mobile')
      ? $mobileFilters.index($clicked)
      : $desktopFilters.index($clicked);

    // apply same index in the currently active set (best match)
    const $toApply = $filters.eq(idxInItsSet);
    if ($toApply.length) applyFilter($toApply);
    else applyFilter($clicked); // fallback
  });

  // If breakpoint changes (resize/orientation), keep active synced and continue auto if not stopped
  $(window).on('resize orientationchange', function () {
    const $newSet = getActiveSet();
    if (!$newSet.length) return;

    // find current active index from old set, apply to new set
    const activeIdx = $filters.index($filters.filter('.active'));
    $filters = $newSet;

    if (!autoStoppedByUser) {
      const idx = activeIdx >= 0 ? activeIdx : 0;
      applyFilter($filters.eq(idx));
      currentIndex = (idx + 1) % $filters.length;
    } else {
      // still keep visuals consistent (active class) even if auto stopped
      const idx = activeIdx >= 0 ? activeIdx : 0;
      $filters.removeClass('active');
      $filters.eq(idx).addClass('active');
    }
  });

  startAuto();
}



  // -------- Numbers counter (animate when in viewport) --------
  function initNumbersCounter() {
    const $numbers = $(nodeSelectors.numbers);
    if (!$numbers.length) return;

    // Prepare all numbers: keep prefix ($, €...), numeric part, and suffix (M+, %, +...)
    $numbers.each(function () {
      const el = this;
      const raw = $(el).text().trim();

      // Examples supported:
      // "$807M+", "€12.5K", "1,250+", "75%", "12.5", "807M+"
      // prefix = anything before first digit
      // number = digits + commas + dot
      // suffix = anything after number
      const match = raw.match(/^([^0-9]*)([\d,.]+)(.*)$/);
      if (!match) return;

      const prefix = match[1] || '';
      const numericText = match[2] || '0';
      const suffix = match[3] || '';

      const target = parseFloat(numericText.replace(/,/g, ''));
      if (Number.isNaN(target)) return;

      // Detect decimals from the numeric part
      const decimals = (numericText.split('.')[1] || '').length;

      el.dataset.prefix = prefix;
      el.dataset.target = String(target);
      el.dataset.suffix = suffix;
      el.dataset.decimals = String(decimals);
      el.dataset.animated = 'false';

      // Start at 0 with same prefix/suffix
      $(el).text(prefix + formatNumber(0, decimals) + suffix);
    });

    // Animate when visible
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          const el = entry.target;
          if (el.dataset.animated === 'true') return;

          animateNumber(el, { duration: 1500 });

          el.dataset.animated = 'true';
          observer.unobserve(el);
        });
      },
      { threshold: 0.4 }
    );

    $numbers.each(function () {
      observer.observe(this);
    });
  }

  function animateNumber(el, { duration = 1500 } = {}) {
    const prefix = el.dataset.prefix || '';
    const suffix = el.dataset.suffix || '';
    const decimals = Number(el.dataset.decimals || 0);
    const target = Number(el.dataset.target || 0);

    const startTime = performance.now();

    function easeOutCubic(t) {
      return 1 - Math.pow(1 - t, 3);
    }

    function tick(now) {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = easeOutCubic(progress);

      const current = target * eased;

      // For integer targets, display integers while animating (less flicker)
      const displayValue =
        decimals > 0 ? current : Math.round(current);

      el.textContent = prefix + formatNumber(displayValue, decimals) + suffix;

      if (progress < 1) {
        requestAnimationFrame(tick);
      } else {
        el.textContent = prefix + formatNumber(target, decimals) + suffix;
      }
    }

    requestAnimationFrame(tick);
  }

  function formatNumber(value, decimals = 0) {
    return Number(value).toLocaleString(undefined, {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });
  }

  return Object.freeze({
    init,
  });
};
